import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import {
    applyLegacyBrandingFallback,
    applyLeapfrogStylesheetFallback,
    setBrandingVars,
} from './utils/BrandingUtils';

const LocaleCodeByLanguageTagMap = {
    en_US: 'en-US',
    es_ES: 'es-ES',
    zh_TW: 'zh-TW',
    fr_CA: 'fr-CA',
};

function getMetaElement(value) {
    const descMeta = document.querySelector(
        "meta[http-equiv='Content-Security-Policy']",
    );

    if (descMeta && descMeta.content === value) return false;

    return true;
}

@inject('localeStore')
@inject('appConfigStore')
@observer
class AppHelmet extends Component {
    static defaultProps = {
        appConfigStore: null,
        localeStore: null,
        modernBrandingStore: null,
    };

    static propTypes = {
        appConfigStore: PropTypes.instanceOf(Object),
        localeStore: PropTypes.instanceOf(Object),
        modernBrandingStore: PropTypes.instanceOf(Object),
    };

    render() {
        const { appConfigStore, localeStore, modernBrandingStore } = this.props;
        const { appConfig } = appConfigStore;
        const {
            modernBranding,
            defaultBrandingUnavailable,
        } = modernBrandingStore;
        const { locale } = localeStore;

        if (!appConfig) {
            return false;
        }
        const modernCSSStylingEnabled =
            appConfig?.modernCSSStylingEnabled ?? false;
        const modernNavigationEnabled =
            modernCSSStylingEnabled &&
            (appConfig?.modernNavigationEnabled ?? false);
        sessionStorage.setItem('modernCSSenabled', modernCSSStylingEnabled);
        sessionStorage.setItem(
            'modernNavigationEnabled',
            String(modernNavigationEnabled),
        );

        if (modernCSSStylingEnabled && !!modernBranding) {
            setBrandingVars(modernBranding);
        } else if (modernCSSStylingEnabled && defaultBrandingUnavailable) {
            applyLegacyBrandingFallback(appConfig);
        } else if (
            appConfig.leapfrogBrandingFile &&
            document.getElementById('leapfrogBrandingStyle') === null &&
            document.getElementById('experience-branding-css') === null &&
            window.parent === window
        ) {
            applyLeapfrogStylesheetFallback(appConfig.leapfrogBrandingFile);
        }

        if (
            appConfig.whiteListDomains &&
            getMetaElement(appConfig.whiteListDomains)
        ) {
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = appConfig.whiteListDomains;
            document.getElementsByTagName('head')[0].appendChild(meta);
        }

        return (
            <Helmet
                htmlAttributes={{
                    lang:
                        LocaleCodeByLanguageTagMap[locale] ??
                        LocaleCodeByLanguageTagMap.en_US,
                }}
            />
        );
    }
}

export default AppHelmet;
